"use strict";

import Util from "/js/util/util.js";
import AppUtil from "/js/util/app-util.js";
import InteractionView from "/js/interaction-views/interaction-view.js";

/**
 * Base class for an interaction that manages multiple screens/questions/steps (`ItemViews`) that
 * get shown in succession (eg, binary-button, multiple-choice).
 */
export default class MultiItemInteractionView extends InteractionView {

  #items = [];
  #index = 0;

  constructor(data, initialAnswers=null) {

    super(data, initialAnswers);

    this.initContent();

    this.$el.on("item-done", $.proxy(this.onAnswer, this));

    // Make only first item visible
    this.#items.forEach(function(item, i) {
      if (i === 0) {
        item.$el.show();
      } else {
        item.$el.hide();
      }
    });

    // Adjust items' ordinal labels to ensure they don't overlap with the interaction title.
    // Not ideal.
    const f = () => {
      const $title = $("#interactionTitle"); // Lives in InteractionHolderView
      const $ordinalLabels = this.$el.find(".ordinal"); // These are abs positioned elements in the #items.
      $ordinalLabels.css("marginTop", $title.height() + "px");
    };
    setTimeout(f, 0);  // Wait for layout pass :(
  }

  get items() {
    return this.#items;
  }

  /** 
   * Subclass should initialize views here.
   */
  initContent() { }

  /* Override */
  show() {
    super.show();

    const item = this.#items[this.#index];
    AppUtil.animInFromBottom(item.$el);
    item.onShow();
  }

  /** 
   * Animates out old item and animates in new item.
   * 
   * Note how the first item does not get animated in, as the entire view gets animated in instead.
   * And the last time does not get animated out, as the entire view gets animated out instead.
   */
  showNextItem() {
    this.#index++;
    if (this.#index >= this.data.questions.length) {
      this.finish();
      return;
    }
    const inItem = this.#items[this.#index];
    AppUtil.animInFromBottom(inItem.$el);
    const outItem = this.#items[this.#index - 1];
    AppUtil.animOutToTop(outItem.$el);
    inItem.onShow();  // TODO: This shd rly be called at end of anim
    Util.windowUnselect();
  }

  /**
   * Override this and save result into `answers` if needed.
   */ 
  onAnswer(e, payload) {
    this.showNextItem();
  }
}
